import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { useTranslation } from "@/hooks/useTranslation";
import SEOHead from "@/components/seo/SEOHead";

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <>
      <SEOHead
        title={t("seo.notFound.title" as any)}
        description={t("seo.notFound.description" as any)}
        noIndex={true}
      />
      <Navbar />
      <main className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center px-4 py-20 max-w-lg">
          <h1 className="text-6xl font-bold mb-4 gradient-text">{t("notFound.title")}</h1>
          <p className="text-2xl font-semibold mb-4">{t("notFound.heading")}</p>
          <p className="text-gray-600 mb-8">
            {t("notFound.message")}
          </p>
          <Link to="/">
            <Button size="lg" className="gradient-bg">
              {t("notFound.button")}
            </Button>
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default NotFound;
